import React from 'react';

const IconPlusPhotoSmall = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" fill="#292A2E"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M10.5 5.25C7.60051 5.25 5.25 7.60051 5.25 10.5C5.25 13.3995 7.60051 15.75 10.5 15.75C13.3995 15.75 15.75 13.3995 15.75 10.5C15.75 7.60051 13.3995 5.25 10.5 5.25ZM3.75 10.5C3.75 6.77208 6.77208 3.75 10.5 3.75C14.2279 3.75 17.25 6.77208 17.25 10.5C17.25 12.0937 16.6977 13.5585 15.774 14.7132L20.0304 18.9697L18.9697 20.0303L14.7133 15.7739C13.5585 16.6976 12.0938 17.25 10.5 17.25C6.77208 17.25 3.75 14.2279 3.75 10.5ZM9.75 7.5V9.75H7.5V11.25H9.75V13.5H11.25V11.25H13.5V9.75H11.25V7.5H9.75Z" fill="white"/>
    </svg>
);

export default IconPlusPhotoSmall;